var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.38758 16L4.68758 10.0842L0.327576 6.10526L6.08758 5.57895L8.32758 0L10.5676 5.57895L16.3276 6.10526L11.9676 10.0842L13.2676 16L8.32758 12.8632L3.38758 16Z",
    fill: "#D4AF37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallStar);
export default __webpack_public_path__ + "static/media/small-star.b13b1a0b97a9b9e73ce93e016f324267.svg";
export { ForwardRef as ReactComponent };